import { logError } from '../../../utils';

const unsubscribeUserFromPush = async () => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      const successful = await subscription.unsubscribe();
      if (!successful) {
        logError(
          'Failed to unsubscribe from push notifications.',
          'unsubscribeUserFromPush.unsubscribeFailed',
        );
      }
      return successful;
    }

    logError(
      'No push subscription to unsubscribe from.',
      'unsubscribeUserFromPush.noSubscription',
    );
    return false;
  } catch (error) {
    logError(
      'Error unsubscribing from push notifications:',
      'unsubscribeUserFromPush.error',
      {
        err: error?.message,
        ...(error?.name && { name: error.name }),
      },
    );
    return null;
  }
};

export default unsubscribeUserFromPush;
